/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { V1StatsByDriversResponse } from '../../entities/v1/StatsByDriversResponse'
import type { ToZod } from '@kubb/plugin-zod/utils'
import { v1StatByDriversDataSchema } from './statByDriversDataSchema'
import { z } from 'zod'

export const v1StatsByDriversResponseSchema = z.object({
  data: z.array(z.lazy(() => v1StatByDriversDataSchema)),
  total: z.number().int(),
}) as unknown as ToZod<V1StatsByDriversResponse>